import { render } from "./ImportantText.vue?vue&type=template&id=710e1cde&scoped=true"
import script from "./ImportantText.vue?vue&type=script&lang=js"
export * from "./ImportantText.vue?vue&type=script&lang=js"

import "./ImportantText.vue?vue&type=style&index=0&id=710e1cde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710e1cde"]])

export default __exports__